import React, { FC } from 'react';

import styles from './index.module.sass';

type IHeaderProps = {
  comingSoon: boolean;
};

export const Header: FC<IHeaderProps> = ({ comingSoon }) => (
  <div className={styles.description}>
    {comingSoon ? (
      <>
        Join in the tradition this spring by celebrating the 90th Masters Tournament April 9-12.
        Sign up below to be notified about 2026 Taste of the Masters &ndash; coming soon.
      </>
    ) : (
      <>
        The taste of tradition never gets old. Elevate your watch party for the 90th Masters
        Tournament, April 9-12, with Taste of the Masters, delivering Augusta National&apos;s
        timeless concessions straight to your door.
      </>
    )}
  </div>
);
